export default __webpack_public_path__ + "static/media/P308.4.77c61fbb.mp3";